/**
 * Deployment mode flags.
 *
 * Standalone / dedicated single-tenant deployments drop all multi-tenant chrome
 * (platform-admin impersonation banner, the "Multi-tenant lead engine | <id>"
 * header tag, the SaaS Control Panel nav entry). Pair with the backend's
 * STANDALONE_MODE=true.
 *
 * craco forwards both spellings, so REACT_APP_STANDALONE (CRA-native) and
 * VITE_STANDALONE both work; whichever is set wins.
 */
const truthy = (v) => ["1", "true", "yes", "on"].includes(String(v ?? "").trim().toLowerCase());

export const IS_STANDALONE =
  truthy(process.env.REACT_APP_STANDALONE) || truthy(process.env.VITE_STANDALONE);

export const INSTITUTION_NAME = (
  process.env.REACT_APP_INSTITUTION_NAME ||
  process.env.VITE_INSTITUTION_NAME ||
  ""
).trim();
